import XIcon from 'feather-icons/dist/icons/x.svg?raw';
import ArrowLeftIcon from 'feather-icons/dist/icons/arrow-left.svg?raw';
import ArrowRightIcon from 'feather-icons/dist/icons/arrow-right.svg?raw';
import ChevronDownIcon from 'feather-icons/dist/icons/chevron-down.svg?raw';

const icons = {
  x: XIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'chevron-down': ChevronDownIcon
};

export const initIcons = () => {
  document.querySelectorAll('[data-feather-icon]').forEach((el) => {
    const iconName = el.getAttribute('data-feather-icon');
    if (icons[iconName]) {
      el.outerHTML = icons[iconName].replace('<svg', '<svg aria-hidden');
    }
  });
};
